import React, { useState, useEffect, useRef } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useWindowWidth, useWindowHeight } from "@react-hook/window-size";
import { isMobile } from "react-device-detect";

import { PageWrapper } from "./components/pageWrapper";
import { LoadingScreen } from "./components/loading";
import { FullHeightMenu, FullHeightMenuWrapper } from "./components/menus";
import {
  ImageCarousel,
  InfoTextDiv,
  FullScreenImageCarousel,
  MultimediaGallery,
  UspModal,
  NavigationBar,
  IconButtonGroup,
  UspIndicatorView,
  FeaturesFrameView,
  ScreenCaptureView,
} from "./components/others";
import { ImageComp } from "./components/image";
import IframeComp from "./components/iframe";
import {
  NotificationModal,
  GyroFrameView,
} from "./components/carSimulatePageComp";

import cars from "./../data/cars.json";
import languages from "./../data/languages.json";
import localization from "./../data/localization.json";
import countries from "./../data/countries.json";
import {
  getLanguageInfo,
  getCarInfo,
  getCountryInfo,
  createPrefixOfUrl,
  createPrefixOfResource,
  gtmModelPageInteraction,
  gtmJourneyEvent,
  gtmJourneyEventWithCustomFields,
  gtmPageView,
  gtmPageStart,
  gtmNavigationInteraction,
  gtmChangeLayeredPage,
  gtmNavigationAction,
  gtmJourneyEventWithUspSpot,
  gtmJourneyEventWithLightMode,
} from "./../common";
import {
  getButtonIconSize,
  getFontClassName,
  getClickHereFontSize,
  getSpecificationWidth,
} from "../styleFunctions";
import { useResponsiveSize } from "./components/hooks";

let debounceTimer = false;
let mouseDownTime = null;

const UspCarousel = ({
  carId,
  inOrEx,
  language,
  slideIdx,
  setSlideIdx,
  setUspUrl,
  setShowUspModal,
  specificationMenuOpened,
  iframeRef,
}) => {
  const windowWidth = useWindowWidth();
  const windowHeight = useWindowHeight();
  const getResponsiveSize = useResponsiveSize();
  const getSpecificationImageWidth = (windowWidth, windowHeight) =>
    getSpecificationWidth(windowWidth, windowHeight) -
    40 * 2 -
    getResponsiveSize(16, 16);
  const getClickHereBtnWidth = (windowWidth, windowHeight) =>
    getSpecificationImageWidth(windowWidth, windowHeight) * 0.541 * 0.6;

  const slideImages = () =>
    getCarInfo(carId)[`spots_${inOrEx}`].map((ele, key) => (
      <div
        key={key}
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "white",
          overflowX: "hidden",
          overflowY: "auto",
        }}
      >
        <ImageComp
          src={
            "mobile_image" in ele
              ? isMobile
                ? ele.mobile_image
                : ele.image
              : ele.image
          }
          alt={`Slide ${key}`}
          style={{
            width: getSpecificationImageWidth(windowWidth, windowHeight),
            height:
              getSpecificationImageWidth(windowWidth, windowHeight) * 0.541,
            margin: 0,
            objectFit: "cover",
          }}
        />
        {ele.usp !== undefined ? (
          <div
            style={{
              position: "absolute",
              cursor: "pointer",
              top:
                (getSpecificationImageWidth(windowWidth, windowHeight) * 0.541 -
                  getClickHereBtnWidth(windowWidth, windowHeight)) /
                2,
              width: getClickHereBtnWidth(windowWidth, windowHeight),
              height: getClickHereBtnWidth(windowWidth, windowHeight),
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              zIndex: 10,
            }}
            onClick={() => {
              if (ele.usp !== undefined) {
                setUspUrl(ele.usp);
                setShowUspModal(true);
                window.localStorage.setItem(
                  "current_usp_name",
                  ele.title[language],
                );
                gtmJourneyEventWithCustomFields(
                  inOrEx === "exterior"
                    ? "view feature"
                    : "view interior feature",
                  getCarInfo(carId).brand,
                  inOrEx,
                  { [`${inOrEx}_feature`]: ele.title[language] },
                );
              }
            }}
          >
            <ImageComp
              alt={`Slide-Cursor-${key}`}
              src="/static/UI/btn-click.png"
              style={{
                width: getClickHereBtnWidth(windowWidth, windowHeight),
                height: getClickHereBtnWidth(windowWidth, windowHeight),
              }}
            />
            <div
              className={getFontClassName("bold", language)}
              style={{
                fontSize: getClickHereFontSize(
                  getClickHereBtnWidth(windowWidth, windowHeight),
                  language,
                ),
                marginTop:
                  (-getClickHereBtnWidth(windowWidth, windowHeight) / 93.6) *
                  33.4286,
                color: "white",
              }}
            >
              {localization["click_here"][language]}
            </div>
          </div>
        ) : ele.external_link !== undefined ? (
          <div
            onClick={() => {
              window.open(ele.external_link, "_blank");
            }}
            style={{
              position: "absolute",
              cursor: "pointer",
              left: getResponsiveSize(8, 8),
              right: getResponsiveSize(8, 8),
              top: 0,
              height:
                getSpecificationImageWidth(windowWidth, windowHeight) * 0.541,
            }}
          ></div>
        ) : (
          <div
            onClick={() => {}}
            style={{
              position: "absolute",
              left: getResponsiveSize(8, 8),
              right: getResponsiveSize(8, 8),
              top: 0,
              height:
                getSpecificationImageWidth(windowWidth, windowHeight) * 0.541,
            }}
          ></div>
        )}
        <div
          className={getFontClassName("light", language)}
          style={{
            width: getSpecificationImageWidth(windowWidth, windowHeight),
            height:
              (windowWidth > windowHeight ? windowHeight : windowHeight / 2) -
              getSpecificationImageWidth(windowWidth, windowHeight) * 0.541 -
              (windowWidth > windowHeight
                ? getResponsiveSize(88, 80) +
                  getResponsiveSize(84, 33) +
                  getResponsiveSize(40, 16) +
                  getResponsiveSize(24, 24)
                : getResponsiveSize(84, 54) + getResponsiveSize(88, 80)) -
              getResponsiveSize(20, 20),
            paddingTop: getResponsiveSize(20, 20),
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              fontSize: getResponsiveSize(20, 20),
              direction: getLanguageInfo(language).rtl ? "rtl" : "ltr",
              textAlign: getLanguageInfo(language).rtl ? "right" : "left",
            }}
            dangerouslySetInnerHTML={{ __html: ele.text[language] }}
          ></div>
        </div>
      </div>
    ));
  return (
    <ImageCarousel
      rtl={getLanguageInfo(language).rtl}
      opened={specificationMenuOpened}
      slideIdx={slideIdx}
      slideImages={slideImages()}
      imageWidth={getSpecificationImageWidth(windowWidth, windowHeight)}
      swipeable={true}
      indexChange={(value) => {
        setSlideIdx((prev) => {
          if (prev < value) {
            gtmJourneyEventWithCustomFields(
              "Click right",
              getCarInfo(carId).brand,
              inOrEx,
              inOrEx === "exterior"
                ? {
                    event_action: `select exterior feature`,
                    exterior_feature:
                      getCarInfo(carId)[`spots_${inOrEx}`][value].title[
                        language
                      ],
                  }
                : {
                    event_action: `select interior feature`,
                    interior_feature:
                      getCarInfo(carId)[`spots_${inOrEx}`][value].title[
                        language
                      ],
                  },
            );
          } else if (prev > value) {
            gtmJourneyEventWithCustomFields(
              "Click left",
              getCarInfo(carId).brand,
              inOrEx,
              inOrEx === "exterior"
                ? {
                    event_action: `select exterior feature`,
                    exterior_feature:
                      getCarInfo(carId)[`spots_${inOrEx}`][value].title[
                        language
                      ],
                  }
                : {
                    event_action: `select interior feature`,
                    interior_feature:
                      getCarInfo(carId)[`spots_${inOrEx}`][value].title[
                        language
                      ],
                  },
            );
          }
          return value;
        });
        iframeRef.current.contentWindow.postMessage(
          JSON.stringify({
            message: "cameraRotateToSpot",
            payload: getCarInfo(carId)[`spots_${inOrEx}`][value].id,
          }),
          "*",
        );
      }}
    ></ImageCarousel>
  );
};

const CarSimulatePage = () => {
  const { carId, inOrEx } = useParams();
  const history = useHistory();
  const { state } = useLocation();
  const notificationShow = useSelector(
    ({ notificationReducer }) => notificationReducer,
  );

  const { loadingRequired, autoComplete } = useSelector(
    ({ loadingStateReducer }) => loadingStateReducer,
  );
  const dispatch = useDispatch();
  const windowWidth = useWindowWidth();
  const windowHeight = useWindowHeight();
  const getResponsiveSize = useResponsiveSize();
  const language = useSelector(
    ({ languageReducer }) => languageReducer.language,
  );
  const country = useSelector(({ countryReducer }) => countryReducer.country);
  const original = useSelector(({ countryReducer }) => countryReducer.original);

  const targetCountry = original?.fullName?.en ?? null;

  // state
  const [willLoadIframe, setWillLoadIframe] = useState(false);
  const [readyURLChange, setReadyURLChange] = useState(false);

  // ui
  const [notificationModalShow, setShowNotificationModal] = useState(true);
  const [fullMenuOpened, setOpenFullMenu] = useState(false);
  const [colorMenuOpened, setOpenColorMenu] = useState(false);
  const [seatMenuOpened, setOpenSeatMenu] = useState(false);
  const [wheelMenuOpened, setOpenWheelMenu] = useState(false);
  const [specificationMenuOpened, setOpenSpecificationMenu] = useState(false);
  const [featuresFrameOpened, setOpenFeaturesFrame] = useState(false);
  const [showScreenCapture, setShowScreenCapture] = useState(false);
  const [slideIdx, setSlideIdx] = useState(0);
  const [lightOnOff, setLightOnOff] = useState(false);
  const [autoPlayOnOff, setAutoPlayOnOff] = useState(true);
  const [showButtons, setButtonsShow] = useState(true);
  const [showGallery, setShowGallery] = useState(false);
  const [showMultimediaGallery, setShowMultimediaGallery] = useState(false);
  const [showUspModal, setShowUspModal] = useState(false);
  const [uspUrl, setUspUrl] = useState(null);
  const [gyroEnabled, setGyroEnabled] = useState(false);

  // iframe
  const [loadingEnded, setLoadingEnded] = useState(false);
  const [carColor, setCarColor] = useState(0);
  const [carSeat, setCarSeat] = useState(0);
  const [carWheel, setCarWheel] = useState(0);

  // capture
  const [capturedScreen, setCapturedScreen] = useState(null);

  const iframeRef = useRef(null);
  const colorMenuRef = useRef(null);
  const wheelMenuRef = useRef(null);
  const seatMenuRef = useRef(null);

  const changeColor = (idx, id) => {
    setCarColor(idx);
    iframeRef.current.contentWindow.postMessage(
      JSON.stringify({
        message: "color",
        payload: id - 1,
      }),
    );
  };

  const changeSeat = (idx) => {
    setCarSeat(idx);
  };

  // style
  const getCarBrands = () => {
    let result = cars.map((ele) => {
      return {
        id: ele.id,
        title: ele.brand,
        carCode: ele.carCode,
        brandHTML: ele.brandHTML,
        onClick: () => {
          gtmNavigationAction("model menu", ele.brand);
          gtmJourneyEvent("model selection", "select vehicle", ele.brand);
          history.push({
            pathname: `${createPrefixOfUrl()}/${ele.id}`,
            state: { inOrEx },
          });
        },
      };
    });
    return result;
  };

  const refItems = getCarInfo(carId)
    .menu.filter((val) => country !== null || val.type === "gallery")
    .map((val) => {
      if (val.type === "multimedia") {
        return {
          title: val.title[language],
          image: null,
          onClick: () => {
            // gtmModelPageInteraction(inOrEx, `Click|multimedia`, getCarInfo(carId).brand)
            gtmNavigationInteraction(
              "tab menu",
              "internal|multimedia",
              getCarInfo(carId).brand,
            );
            setShowMultimediaGallery(true);
          },
          inactive: false,
        };
      } else if (val.type === "gallery") {
        return {
          title: val.title[language],
          image: null,
          onClick: () => {
            // gtmModelPageInteraction(inOrEx, `Click|gallery`, getCarInfo(carId).brand)
            gtmNavigationInteraction(
              "tab menu",
              "internal|gallery",
              getCarInfo(carId).brand,
            );
            setShowGallery(true);
          },
          inactive: false,
        };
      } else {
        let inactive = false;
        try {
          inactive =
            val.value === null ||
            val.value[country] === null ||
            val.value[country][language] === null;
        } catch (err) {}
        return {
          title: val.title[language],
          image: null,
          onClick: () => {
            // gtmModelPageInteraction(inOrEx, `Click|${val.title[language]}`, getCarInfo(carId).brand)
            gtmNavigationInteraction(
              "tab menu",
              `external|${val.title[language]}`,
              getCarInfo(carId).brand,
            );
            window.open(val.value[country][language]);
          },
          inactive: inactive,
        };
      }
    });

  const getNotificationModalWidth = () => {
    if (windowWidth > 1024) {
      return 581;
    } else if (windowWidth >= 840) {
      return windowWidth * 0.88;
    } else {
      return windowWidth * 0.8;
    }
  };

  const getNotificationIconWidth = () => {
    if (windowWidth > 1024) {
      return 50;
    } else if (windowWidth >= 840) {
      return 98;
    } else {
      return 34;
    }
  };

  const getNotificationModalPartStyle1 = () => {
    if (windowWidth > windowHeight) {
      return {
        flex: 1,
        direction: getLanguageInfo(language).rtl ? "rtl" : "ltr",
        borderLeft: getLanguageInfo(language).rtl
          ? "2px solid rgb(202, 202, 202)"
          : "none",
        paddingRight: getLanguageInfo(language).rtl ? 0 : "24px",
        paddingLeft: getLanguageInfo(language).rtl ? "24px" : 0,
      };
    } else {
      return {
        borderBottom: "2px solid rgb(202, 202, 202)",
        direction: getLanguageInfo(language).rtl ? "rtl" : "ltr",
        paddingBottom: "16px",
      };
    }
  };

  const getNotificationModalPartStyle2 = () => {
    if (windowWidth > windowHeight) {
      return {
        flex: 1,
        borderLeft: getLanguageInfo(language).rtl
          ? "none"
          : "2px solid rgb(202, 202, 202)",
        direction: getLanguageInfo(language).rtl ? "rtl" : "ltr",
        paddingLeft: getLanguageInfo(language).rtl ? 0 : "24px",
        paddingRight: getLanguageInfo(language).rtl ? "24px" : 0,
      };
    } else {
      return {
        direction: getLanguageInfo(language).rtl ? "rtl" : "ltr",
        paddingTop: "16px",
        display: "flex",
        flexWrap: "wrap",
      };
    }
  };

  const getIframeStyle = () => {
    if (windowWidth > windowHeight)
      return {
        marginLeft: getLanguageInfo(language).rtl
          ? specificationMenuOpened
            ? getSpecificationWidth(windowWidth, windowHeight)
            : colorMenuOpened || wheelMenuOpened
              ? getResponsiveSize(405, 405)
              : 0
          : 0,
        width: specificationMenuOpened
          ? `calc(100% - ${getSpecificationWidth(windowWidth, windowHeight)}px)`
          : colorMenuOpened || wheelMenuOpened
            ? `calc(100% - ${getResponsiveSize(405, 405)}px)`
            : "100%",
        height: "100%",
        border: "none",
        outline: "none",
        padding: 0,
        marginRight: 0,
        marginBottom: 0,
        marginTop: 0,
      };
    else {
      return {
        width: "100%",
        height: specificationMenuOpened
          ? window.innerHeight - windowHeight / 2
          : colorMenuOpened
            ? window.innerHeight - getResponsiveSize(391, 391)
            : wheelMenuOpened
              ? window.innerHeight - getResponsiveSize(316, 316)
              : "100%",
        border: "none",
        outline: "none",
        padding: 0,
        margin: 0,
      };
    }
  };

  const getColorSelectorSize = () => getResponsiveSize(80, 80);
  const getWheelSelectorSize = () => getResponsiveSize(154, 154);

  const getColorIndex = () => {
    var carInfo = getCarInfo(carId);
    var idx = carInfo.colors.findIndex(
      (colorInfo) => colorInfo.id === carInfo.defaultColorID,
    );
    return idx;
  };

  useEffect(() => {
    var newColor = Math.max(getColorIndex(), 0);
    window.iframeEventInfo.inOrEx = inOrEx;
    window.onmessage = (event) => {
      try {
        const data = event.data;
        const obj = JSON.parse(data);
        switch (obj.message) {
          case "spotClicked":
            let spotIdx = getCarInfo(carId)[`spots_${inOrEx}`].findIndex(
              (ele) => ele.id === Number(obj.payload),
            );
            if (spotIdx !== -1) {
              setOpenFullMenu(false);
              setButtonsShow(false);
              setSlideIdx(spotIdx);
              setOpenSpecificationMenu(true);
              iframeRef.current.contentWindow.postMessage(
                JSON.stringify({ message: "hideUISpots" }),
              );
              iframeRef.current.contentWindow.postMessage(
                JSON.stringify({
                  message: "cameraRotate",
                  payload: false,
                }),
                "*",
              );
              iframeRef.current.contentWindow.postMessage(
                JSON.stringify({
                  message: "cameraRotateToSpot",
                  payload: obj.payload,
                }),
                "*",
              );
              let lang_id = window.localStorage.getItem("lang_id");
              gtmModelPageInteraction(
                inOrEx,
                `Click|${getCarInfo(carId)[`spots_${inOrEx}`][spotIdx].title[lang_id]}`,
                getCarInfo(carId).brand,
              );
              gtmJourneyEventWithUspSpot(
                getCarInfo(carId)[`spots_${inOrEx}`][spotIdx].title[lang_id],
                getCarInfo(carId).brand,
                inOrEx,
              );
            }
            break;
          case "scriptLoaded":
            /* script is loaded. now we can load engine */
            iframeRef.current.contentWindow.postMessage(
              JSON.stringify({ message: "loadEngine" }),
              "*",
            );
            break;
          case "engineLoaded":
            /* engine is loaded. now we can load a scene(exterior / interior) */
            /* load exterior / interior */
            setTimeout(() => {
              if (inOrEx === "exterior") {
                iframeRef.current.contentWindow.postMessage(
                  JSON.stringify({ message: getCarInfo(carId).exteriorValue }),
                  "*",
                );
              } else if (inOrEx === "interior") {
                iframeRef.current.contentWindow.postMessage(
                  JSON.stringify({ message: getCarInfo(carId).interiorValue }),
                  "*",
                );
              }
            }, 1000);
            break;
          case "sceneLoaded":
            /* scene is loaded. now we can control everything */
            window.localStorage.setItem("sceneLoaded", "yes");
            setReadyURLChange(true);
            iframeRef.current.contentWindow.postMessage(
              JSON.stringify({
                message: "color",
                payload: getCarInfo(carId).colors[newColor].id - 1,
              }),
            );
            setTimeout(() => {
              setTimeout(() => {
                /* FOR EXTERIOR ONLY */
                if (inOrEx === "exterior") {
                  iframeRef.current.contentWindow.postMessage(
                    JSON.stringify({
                      message: "cameraRotate",
                      payload: true,
                    }),
                  );
                }
              }, 500);
            }, 200);
            break;
          case "goInteriorClicked":
            gtmModelPageInteraction(
              inOrEx,
              `Click|go to interior`,
              getCarInfo(carId).brand,
            );
            gtmJourneyEvent(
              "exterior/interior",
              "select interior",
              getCarInfo(carId).brand,
              "exterior",
            );
            history.replace(`${createPrefixOfUrl()}/${carId}/interior`);
            break;
          case "goExteriorClicked":
            gtmModelPageInteraction(
              inOrEx,
              `Click|go to exterior`,
              getCarInfo(carId).brand,
            );
            gtmJourneyEvent(
              "exterior/interior",
              "select exterior",
              getCarInfo(carId).brand,
              "interior",
            );
            history.replace(`${createPrefixOfUrl()}/${carId}/exterior`);
            break;
          case "lampChanged":
            gtmJourneyEventWithCustomFields(
              "select light mode",
              getCarInfo(carId).brand,
              inOrEx,
              { lights_mode: obj.payload ? "on" : "off" },
            );
            gtmNavigationInteraction(
              "sticky menu",
              obj.payload ? "change to day" : "change to night",
              getCarInfo(carId).brand,
            );
            break;
          case "zoomChanged":
            if (inOrEx !== null) {
              if (!debounceTimer) {
                debounceTimer = true;
                gtmModelPageInteraction(
                  inOrEx,
                  `impressions|${inOrEx}`,
                  getCarInfo(carId).brand,
                );
                setTimeout(() => (debounceTimer = false), 1000);
              }
            }
            break;
          case "screenshotTaken":
            setCapturedScreen(obj.payload);
            break;
          case "doorOpenButtonClicked":
            gtmModelPageInteraction(
              "exterior",
              "Click|door open",
              getCarInfo(carId).brand,
            );
            gtmJourneyEvent(
              "action spot",
              "door open",
              getCarInfo(carId).brand,
            );
            break;
          case "doorCloseButtonClicked":
            gtmModelPageInteraction(
              "exterior",
              "Click|door close",
              getCarInfo(carId).brand,
            );
            gtmJourneyEvent(
              "action spot",
              "door close",
              getCarInfo(carId).brand,
            );
            break;
          case "wheelMoveButtonClicked":
            gtmModelPageInteraction(
              "exterior",
              "Click|wheel movement",
              getCarInfo(carId).brand,
            );
            gtmJourneyEvent(
              "action spot",
              "wheel movement",
              getCarInfo(carId).brand,
            );
            break;
          case "sideMirrorMoveButtonClicked":
            gtmModelPageInteraction(
              "exterior",
              "Click|side mirror movement",
              getCarInfo(carId).brand,
            );
            gtmJourneyEvent(
              "action spot",
              "side mirror movement",
              getCarInfo(carId).brand,
            );
            break;
          case "lightMenuOpenClicked":
            gtmModelPageInteraction(
              "exterior",
              "Click|light menu open",
              getCarInfo(carId).brand,
            );
            gtmJourneyEvent(
              "action spot",
              "light menu open",
              getCarInfo(carId).brand,
            );
            break;
          case "lightMenuCloseClicked":
            gtmModelPageInteraction(
              "exterior",
              "Click|light menu close",
              getCarInfo(carId).brand,
            );
            gtmJourneyEvent(
              "action spot",
              "light menu close",
              getCarInfo(carId).brand,
            );
            break;
          case "taillightTurned":
            gtmModelPageInteraction(
              "exterior",
              `Click|taillight ${obj.payload ? "on" : "off"}`,
              getCarInfo(carId).brand,
            );
            gtmJourneyEventWithLightMode(
              "select taillight",
              getCarInfo(carId).brand,
              obj.payload ? "on" : "off",
            );
            break;
          case "turnSignalTurned":
            gtmModelPageInteraction(
              "exterior",
              `Click|turn signal ${obj.payload ? "on" : "off"}`,
              getCarInfo(carId).brand,
            );
            gtmJourneyEventWithLightMode(
              "select turn signal",
              getCarInfo(carId).brand,
              obj.payload ? "on" : "off",
            );
            break;
          case "lowBeamTurned":
            gtmModelPageInteraction(
              "exterior",
              `Click|low beam ${obj.payload ? "on" : "off"}`,
              getCarInfo(carId).brand,
            );
            gtmJourneyEventWithLightMode(
              "select low beam",
              getCarInfo(carId).brand,
              obj.payload ? "on" : "off",
            );
            break;
          case "highBeamTurned":
            gtmModelPageInteraction(
              "exterior",
              `Click|high beam ${obj.payload ? "on" : "off"}`,
              getCarInfo(carId).brand,
            );
            gtmJourneyEventWithLightMode(
              "select high beam",
              getCarInfo(carId).brand,
              obj.payload ? "on" : "off",
            );
            break;
          case "tagmgr_usp_step4":
            break;
          case "tagmgr_usp_step_play":
            break;
          case "tagmgr_usp_step_complete":
            break;
          default:
            break;
        }
      } catch (e) {}
    };
    setShowNotificationModal(true);
    setOpenFullMenu(false);
    setOpenSpecificationMenu(false);
    setOpenFeaturesFrame(false);
    setOpenColorMenu(false);
    setOpenSeatMenu(false);
    setOpenWheelMenu(false);
    setButtonsShow(true);
    setCarWheel(0);
    setCarSeat(0);
    setLightOnOff(false);
    setAutoPlayOnOff(true);
    setSlideIdx(0);
    //
    setReadyURLChange(false);
    if (willLoadIframe) {
      setTimeout(() => {
        if (inOrEx === "exterior") {
          iframeRef.current.contentWindow.postMessage(
            JSON.stringify({
              message: getCarInfo(carId).exteriorValue,
            }),
            "*",
          );

          setTimeout(() => {
            setCarColor(Math.max(getColorIndex(), 0));
            iframeRef.current.contentWindow.postMessage(
              JSON.stringify({
                message: "cameraRotate",
                payload: true,
              }),
              "*",
            );
          }, 500);
        } else if (inOrEx === "interior") {
          iframeRef.current.contentWindow.postMessage(
            JSON.stringify({
              message: getCarInfo(carId).interiorValue,
            }),
            "*",
          );
        }
      }, 200);
    }
  }, [inOrEx]);

  useEffect(() => {
    setShowNotificationModal(true);
    setOpenFullMenu(false);
    setOpenSpecificationMenu(false);
    setOpenFeaturesFrame(false);
    setOpenColorMenu(false);
    setOpenSeatMenu(false);
    setOpenWheelMenu(false);
    setButtonsShow(true);
    if (state !== undefined && state.color !== null) {
      setCarColor(state.color);
    } else {
      setCarColor(Math.max(getColorIndex(), 0));
    }
    setCarWheel(0);
    setCarSeat(0);
    setLightOnOff(false);
    setAutoPlayOnOff(true);
    setSlideIdx(0);
    //
    setWillLoadIframe(false);
    setReadyURLChange(false);
    window.localStorage.setItem("engineLoadProgress", 0);
    window.localStorage.setItem("sceneLoaded", "no");
    setLoadingEnded(false);
    dispatch({ type: "CHANGE_LOADING_REQUIRED", value: true });
  }, [carId]);

  useEffect(() => {
    try {
      if (specificationMenuOpened || featuresFrameOpened) {
        iframeRef.current.contentWindow.postMessage(
          JSON.stringify({
            message: "spotSelected",
            payload: `${getCarInfo(carId)[`spots_${inOrEx}`][slideIdx].id}`,
          }),
          "*",
        );
      } else {
        iframeRef.current.contentWindow.postMessage(
          JSON.stringify({
            message: "spotSelected",
            payload: "",
          }),
          "*",
        );
      }
    } catch (err) {}
  }, [
    slideIdx,
    specificationMenuOpened,
    featuresFrameOpened,
    carId,
    inOrEx,
    language,
  ]);

  useEffect(() => {
    if (!targetCountry) {
      return;
    }

    gtmPageView(
      "vehicle",
      getCarInfo(carId).brand,
      getCarInfo(carId).carCode,
      inOrEx,
      targetCountry,
    );
  }, [carId, inOrEx, targetCountry]);

  useEffect(() => {
    if (loadingRequired && !loadingEnded) {
      window.iframeEventInfo.added = false;
    } else {
      if (
        !window.iframeEventInfo.added &&
        iframeRef.current &&
        iframeRef.current.contentWindow.document
      ) {
        let canvasEle =
          iframeRef.current.contentWindow.document.getElementById(
            "application-canvas",
          );
        let eventHandler = () =>
          window.iframeEventInfo.inOrEx !== null &&
          gtmModelPageInteraction(
            window.iframeEventInfo.inOrEx,
            `impressions|${window.iframeEventInfo.inOrEx}`,
            getCarInfo(carId).brand,
          );
        canvasEle.addEventListener("mousedown", () => {
          mouseDownTime = new Date().getTime();
        });
        canvasEle.addEventListener("touchstart", () => {
          mouseDownTime = new Date().getTime();
        });
        canvasEle.addEventListener("mouseup", () => {
          if (mouseDownTime !== null) {
            let currentTime = new Date().getTime();
            if (currentTime > mouseDownTime + 400) eventHandler();
          }
          mouseDownTime = null;
        });
        canvasEle.addEventListener("touchend", () => {
          if (mouseDownTime !== null) {
            let currentTime = new Date().getTime();
            if (currentTime > mouseDownTime + 400) eventHandler();
          }
          mouseDownTime = null;
        });
        // canvasEle.addEventListener('wheel', () => {
        //     if (!debounceTimer) {
        //         debounceTimer = true
        //         eventHandler()
        //         setTimeout(() => debounceTimer = false, 1500)
        //     }
        // })
        // canvasEle.addEventListener('touchstart', eventHandler)
        window.iframeEventInfo.added = true;
      }
    }
  }, [carId, loadingRequired, loadingEnded, iframeRef]);

  useEffect(() => {
    if (
      language !== null &&
      iframeRef.current !== null &&
      iframeRef.current.contentWindow
    ) {
      console.log("setLanguage", language);
      iframeRef.current.contentWindow.postMessage(
        JSON.stringify({
          message: "setLanguage",
          payload: language,
        }),
        "*",
      );
    }
  }, [language, iframeRef]);

  const colorDisclaimer = getCarInfo(carId)["color_disclaimer"];

  return (
    <>
      {loadingRequired && !loadingEnded ? (
        <LoadingScreen
          cars={[getCarInfo(carId)]}
          realLoad
          autoComplete={autoComplete}
          middleFunction={() => setWillLoadIframe(true)}
          completeFunction={(lang_id = null) => {
            if (lang_id !== null) {
              dispatch({ type: "LANGUAGE_CHANGED", language: lang_id });
            }
            gtmPageStart();
            setTimeout(() => {
              setLoadingEnded(true);
              dispatch({ type: "CHANGE_LOADING_REQUIRED", value: false });
              dispatch({ type: "CHANGE_AUTO_COMPLETED", value: true });
              iframeRef.current.contentWindow.postMessage(
                JSON.stringify({
                  message: "cameraRotate360",
                }),
                "*",
              );
              setCarColor((prev) => {
                iframeRef.current.contentWindow.postMessage(
                  JSON.stringify({
                    message: "color",
                    payload: prev,
                  }),
                );
                return prev;
              });

              setLightOnOff((prev) => {
                if (getCarInfo(carId).lightOnOff && !prev) {
                  iframeRef.current.contentWindow.postMessage(
                    JSON.stringify({
                      message: "setDay",
                      payload: false,
                    }),
                    "*",
                  );
                  return true;
                } else {
                  return prev;
                }
              });
              if (languages.length > 1 && lang_id !== null) {
                gtmNavigationInteraction(
                  "cta click",
                  getLanguageInfo(lang_id).title,
                  getCarInfo(carId).brand,
                );
              } else {
                gtmNavigationInteraction(
                  "cta click",
                  "start",
                  getCarInfo(carId).brand,
                );
              }
            }, 1000);
          }}
        />
      ) : null}
      {willLoadIframe ? (
        <PageWrapper carId={carId}>
          <div
            style={{
              width: "100%",
              height: "100%",
              overflow: "hidden",
              display: loadingEnded ? "block" : "none",
            }}
          >
            {getCarInfo(carId).modelSrc && willLoadIframe ? (
              <IframeComp
                ref={iframeRef}
                src={
                  isMobile
                    ? getCarInfo(carId).modelMobileSrc
                    : getCarInfo(carId).modelSrc
                }
                style={getIframeStyle()}
                title={`${carId}-${inOrEx}`}
              />
            ) : (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  padding: 0,
                  margin: 0,
                  backgroundColor: "grey",
                }}
              ></div>
            )}
            {showButtons ? (
              <>
                <NavigationBar
                  onMenuClick={() => {
                    setOpenFullMenu(true);
                    gtmNavigationInteraction(
                      "sticky menu",
                      "menu",
                      getCarInfo(carId).brand,
                    );
                    gtmChangeLayeredPage(
                      getCarInfo(carId).carCode,
                      "galleries",
                    );
                  }}
                  language={language}
                >
                  <div
                    style={{
                      position: "fixed",
                      [language !== null && getLanguageInfo(language).rtl
                        ? "left"
                        : "right"]: getResponsiveSize(141, 118),
                      top: getResponsiveSize(26, 26),
                      width: getResponsiveSize(38, 38),
                      height: getResponsiveSize(27, 27),
                      zIndex: 5,
                    }}
                  >
                    <ImageComp
                      src={"/static/UI/btn-share.png"}
                      style={{
                        width: "100%",
                        height: "100%",
                        cursor: "pointer",
                      }}
                      alt="book online"
                      onClick={() => {
                        setButtonsShow(false);
                        setShowScreenCapture(true);
                        iframeRef.current.contentWindow.postMessage(
                          JSON.stringify({ message: "hideAllSpots" }),
                          "*",
                        );
                        iframeRef.current.contentWindow.postMessage(
                          JSON.stringify({
                            message: "cameraRotate",
                            payload: false,
                          }),
                        );
                        gtmNavigationInteraction(
                          "sticky menu",
                          "camera",
                          getCarInfo(carId).brand,
                        );
                      }}
                    />
                  </div>
                  {cars.length > 1 ? (
                    <div
                      style={{
                        position: "fixed",
                        [language !== null && getLanguageInfo(language).rtl
                          ? "right"
                          : "left"]: getResponsiveSize(59, 38),
                        top: getResponsiveSize(22, 22),
                        width: getResponsiveSize(42, 42),
                        height: getResponsiveSize(36, 36),
                        zIndex: 5,
                      }}
                    >
                      <ImageComp
                        src={"/static/UI/ic-showroom.png"}
                        style={{
                          width: "100%",
                          height: "100%",
                          cursor: "pointer",
                        }}
                        alt="showroom"
                        onClick={() => {
                          gtmNavigationInteraction(
                            "sticky menu",
                            "showroom",
                            getCarInfo(carId).brand,
                          );
                          history.push(`${createPrefixOfUrl()}/showroom`, {
                            current_car: carId,
                          });
                        }}
                      />
                    </div>
                  ) : null}
                  {getCarInfo(carId).bookOnlineLink &&
                    getCarInfo(carId).bookOnlineLink[country] &&
                    getCarInfo(carId).bookOnlineLink[country][language] && (
                      <div
                        style={{
                          position: "fixed",
                          [language !== null && getLanguageInfo(language).rtl
                            ? "left"
                            : "right"]: getResponsiveSize(220, 197),
                          top: getResponsiveSize(23, 23),
                          width: getResponsiveSize(38, 38),
                          height: getResponsiveSize(39, 39),
                          zIndex: 5,
                        }}
                      >
                        <ImageComp
                          src={"/static/UI/btn-bookonline.png"}
                          style={{
                            width: "100%",
                            height: "100%",
                            cursor: "pointer",
                          }}
                          alt="book online"
                          onClick={() => {
                            window.open(
                              getCarInfo(carId).bookOnlineLink[country][
                                language
                              ],
                              "_blank",
                            );
                            gtmNavigationInteraction(
                              "sticky menu",
                              "book online",
                              getCarInfo(carId).brand,
                            );
                          }}
                        />
                      </div>
                    )}
                </NavigationBar>
                <IconButtonGroup
                  buttons={
                    inOrEx === "exterior"
                      ? [
                          getCarInfo(carId).spots_exterior.length > 0
                            ? {
                                title:
                                  localization["notification_txt_5"][language],
                                src: "/static/UI/btn-features.png",
                                onClick: () => {
                                  setButtonsShow(false);
                                  setOpenFeaturesFrame(true);
                                  gtmNavigationInteraction(
                                    "sticky menu",
                                    "exterior features",
                                    getCarInfo(carId).brand,
                                  );
                                  iframeRef.current.contentWindow.postMessage(
                                    JSON.stringify({ message: "cameraRotate" }),
                                  );
                                  iframeRef.current.contentWindow.postMessage(
                                    JSON.stringify({ message: "hideUISpots" }),
                                  );
                                  iframeRef.current.contentWindow.postMessage(
                                    JSON.stringify({
                                      message: "cameraRotateToSpot",
                                      payload:
                                        getCarInfo(carId)[`spots_${inOrEx}`][
                                          slideIdx
                                        ].id,
                                    }),
                                    "*",
                                  );
                                },
                              }
                            : null,
                          {
                            title: localization["notification_txt_4"][language],
                            src: "/static/UI/btn-wheel.png",
                            onClick: () => {
                              setOpenFullMenu(false);
                              setButtonsShow(false);
                              setOpenWheelMenu(true);
                              gtmNavigationInteraction(
                                "sticky menu",
                                "wheel",
                                getCarInfo(carId).brand,
                              );
                              iframeRef.current.contentWindow.postMessage(
                                JSON.stringify({
                                  message: "cameraRotate",
                                  payload: false,
                                }),
                              );
                              iframeRef.current.contentWindow.postMessage(
                                JSON.stringify({ message: "cameraWheel" }),
                                "*",
                              );
                              iframeRef.current.contentWindow.postMessage(
                                JSON.stringify({ message: "hideAllSpots" }),
                                "*",
                              );
                            },
                          },
                          {
                            title: localization["notification_txt_3"][language],
                            src: "/static/UI/btn-color.png",
                            onClick: () => {
                              setOpenFullMenu(false);
                              setButtonsShow(false);
                              setOpenColorMenu(true);
                              gtmNavigationInteraction(
                                "sticky menu",
                                "color",
                                getCarInfo(carId).brand,
                              );
                              iframeRef.current.contentWindow.postMessage(
                                JSON.stringify({
                                  message: "cameraRotate",
                                  payload: false,
                                }),
                              );
                              iframeRef.current.contentWindow.postMessage(
                                JSON.stringify({
                                  message: isMobile
                                    ? "cameraResetMobile"
                                    : "cameraReset",
                                }),
                                "*",
                              );
                              // iframeRef.current.contentWindow.postMessage(
                              //   JSON.stringify({
                              //     message: "cameraSet",
                              //     payload: [100, 100, 30],
                              //   }),
                              //   "*",
                              // );
                              iframeRef.current.contentWindow.postMessage(
                                JSON.stringify({ message: "hideAllSpots" }),
                                "*",
                              );
                            },
                          },
                        ]
                      : [
                          getCarInfo(carId).spots_interior.length > 0
                            ? {
                                title:
                                  localization["notification_txt_5"][language],
                                src: "/static/UI/btn-features.png",
                                onClick: () => {
                                  setButtonsShow(false);
                                  setOpenFeaturesFrame(true);
                                  gtmNavigationInteraction(
                                    "sticky menu",
                                    "interior features",
                                    getCarInfo(carId).brand,
                                  );
                                  iframeRef.current.contentWindow.postMessage(
                                    JSON.stringify({ message: "cameraRotate" }),
                                  );
                                  iframeRef.current.contentWindow.postMessage(
                                    JSON.stringify({ message: "hideUISpots" }),
                                  );
                                  iframeRef.current.contentWindow.postMessage(
                                    JSON.stringify({
                                      message: "cameraRotateToSpot",
                                      payload:
                                        getCarInfo(carId)[`spots_${inOrEx}`][
                                          slideIdx
                                        ].id,
                                    }),
                                    "*",
                                  );
                                },
                              }
                            : null,
                          isMobile
                            ? {
                                title:
                                  localization["notification_txt_11"][language],
                                src: "/static/UI/btn-gyroscope.png",
                                onClick: () => {
                                  if (
                                    typeof window.DeviceOrientationEvent !==
                                      "undefined" &&
                                    typeof window.DeviceOrientationEvent
                                      .requestPermission === "function"
                                  ) {
                                    window.DeviceOrientationEvent.requestPermission().then(
                                      (permissionState) => {
                                        if (permissionState === "granted") {
                                          setButtonsShow(false);
                                          iframeRef.current.contentWindow.postMessage(
                                            JSON.stringify({
                                              message: "gyroscope",
                                              payload: true,
                                            }),
                                            "*",
                                          );
                                          setGyroEnabled(true);
                                        } else {
                                          alert("You cannot use this ability");
                                        }
                                      },
                                    );
                                  } else {
                                    setButtonsShow(false);
                                    iframeRef.current.contentWindow.postMessage(
                                      JSON.stringify({
                                        message: "gyroscope",
                                        payload: true,
                                      }),
                                      "*",
                                    );
                                    setGyroEnabled(true);
                                  }
                                  gtmNavigationInteraction(
                                    "sticky menu",
                                    "gyroscope",
                                    getCarInfo(carId).brand,
                                  );
                                },
                              }
                            : null,
                          {
                            title:
                              localization["notification_txt_17"][language],
                            src: "/static/UI/btn-seat.png",
                            onClick: () => {
                              setOpenFullMenu(false);
                              setButtonsShow(false);
                              setOpenSeatMenu(true);
                              gtmNavigationInteraction(
                                "sticky menu",
                                `seat`,
                                getCarInfo(carId).brand,
                              );
                              // iframeRef.current.contentWindow.postMessage(JSON.stringify({ message: 'hideAllSpots' }), '*')
                            },
                          },
                        ]
                  }
                  language={language}
                />
              </>
            ) : null}
            <FullHeightMenu
              width={
                windowWidth > 1024 ? getResponsiveSize(540, 540) : windowWidth
              }
              titleHTML={getCarInfo(carId).brandHTML}
              menuItems={refItems}
              cars={getCarBrands()}
              opened={fullMenuOpened}
              closeFunc={() => {
                setOpenFullMenu(false);
                gtmChangeLayeredPage(getCarInfo(carId).carCode, inOrEx);
              }}
              languageInfo={getLanguageInfo(language)}
              carId={carId}
              languages={languages}
              countries={countries}
              countryInfo={getCountryInfo(country)}
            />
            <GyroFrameView
              gyroEnabled={gyroEnabled}
              language={language}
              closeFunc={() => {
                setButtonsShow(true);
                iframeRef.current.contentWindow.postMessage(
                  JSON.stringify({
                    message: "gyroscope",
                    payload: false,
                  }),
                  "*",
                );
                setGyroEnabled(false);
              }}
            />
            <FullHeightMenuWrapper
              width={getResponsiveSize(405, 405)}
              mobileHeight={getResponsiveSize(391, colorDisclaimer ? 500 : 391)}
              subTitle={getCarInfo(carId).colors[carColor]["name"][language]}
              opened={colorMenuOpened}
              closeFunc={() => {
                setButtonsShow(true);
                setOpenColorMenu(false);
                if (autoPlayOnOff)
                  iframeRef.current.contentWindow.postMessage(
                    JSON.stringify({
                      message: "cameraRotate",
                      payload: true,
                    }),
                  );
                iframeRef.current.contentWindow.postMessage(
                  JSON.stringify({ message: "showAllSpots" }),
                );
              }}
              languageInfo={getLanguageInfo(language)}
            >
              <div
                ref={colorMenuRef}
                style={{
                  position: "relative",
                  overflowX: "hidden",
                  overflowY: "auto",
                  marginTop: getResponsiveSize(19, 19),
                  marginBottom: 0,
                  width: "100%",
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  flexWrap: "wrap",
                }}
              >
                {getCarInfo(carId).colors.map((ele, idx) => {
                  return (
                    <div
                      key={`color-${idx}`}
                      style={{
                        width: windowWidth > windowHeight ? "33%" : "25%",
                        textAlign:
                          (windowWidth > 1024 && idx % 3) === 0
                            ? "left"
                            : windowWidth > 1024 && idx % 3 === 2
                              ? "right"
                              : "center",
                      }}
                    >
                      <ImageComp
                        alt={`color-${idx}`}
                        src={ele.image}
                        style={{
                          cursor: "pointer",
                          borderRadius: getColorSelectorSize() * 0.6,
                          padding: `${getColorSelectorSize() * 0.1}px`,
                          margin: `${getResponsiveSize(12, 12)}px 0px`,
                          width: getColorSelectorSize(),
                          height: getColorSelectorSize(),
                          background:
                            idx === carColor ? "#cdd0d2" : "transparent",
                        }}
                        onClick={() => {
                          changeColor(idx, ele.id);
                          gtmJourneyEventWithCustomFields(
                            "select exterior color",
                            getCarInfo(carId).brand,
                            inOrEx,
                            { color_exterior: ele.name[language] },
                          );
                        }}
                      />
                    </div>
                  );
                })}
              </div>
              {isMobile &&
              colorMenuOpened &&
              getCarInfo(carId).colors.length > 8 ? (
                <ImageComp
                  src="/static/UI/btn_arrow.png"
                  alt="color-scroll-bottom-button"
                  style={{
                    position: "fixed",
                    width: 50,
                    height: 50,
                    cursor: "pointer",
                    right: 16,
                    bottom: 16,
                    transform: "rotate(-90deg)",
                    opacity: 0.7,
                  }}
                  onClick={() => colorMenuRef.current.scrollBy(0, 1000000)}
                />
              ) : null}
              {/* Color D */}
              {colorDisclaimer && (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <p
                    className={getFontClassName("light", language)}
                    style={{
                      fontSize: 12,
                    }}
                  >
                    * {colorDisclaimer[language]}
                  </p>
                </div>
              )}
            </FullHeightMenuWrapper>
            <FullHeightMenuWrapper
              width={getResponsiveSize(405, 405)}
              mobileHeight={getResponsiveSize(350, 350)}
              title={
                getCarInfo(carId).seatCustomTitle
                  ? getCarInfo(carId).seatCustomTitle[language]
                  : localization["notification_txt_13"][language]
              }
              subTitle={getCarInfo(carId).seats[carSeat]["name"][language]}
              disclaimer={
                getCarInfo(carId).seats[carSeat]["disclaimer"]
                  ? getCarInfo(carId).seats[carSeat]["disclaimer"][language]
                  : null
              }
              opened={seatMenuOpened}
              closeFunc={() => {
                setButtonsShow(true);
                setOpenSeatMenu(false);
              }}
              languageInfo={getLanguageInfo(language)}
            >
              <div
                ref={seatMenuRef}
                style={{
                  flex: 1,
                  overflowX: "hidden",
                  overflowY: "auto",
                  marginTop: getResponsiveSize(36, 36),
                  marginBottom: getResponsiveSize(16, 16),
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                }}
              >
                {getCarInfo(carId).seats.map((ele, idx) => {
                  return (
                    <div
                      key={`seat-${idx}`}
                      style={{
                        width: windowWidth > windowHeight ? "33%" : "25%",
                        textAlign:
                          (windowWidth > 1024 && idx % 3) === 0
                            ? "left"
                            : windowWidth > 1024 && idx % 3 === 2
                              ? "right"
                              : "center",
                      }}
                    >
                      <ImageComp
                        alt={`seat-${idx}`}
                        src={ele.image}
                        style={{
                          cursor: "pointer",
                          borderRadius: getResponsiveSize(48, 48),
                          padding: getResponsiveSize(8, 8),
                          width: getResponsiveSize(80, 80),
                          height: getResponsiveSize(80, 80),
                          background: idx === carSeat ? "#eee" : "transparent",
                        }}
                        onClick={() => {
                          if (
                            getCarInfo(carId).seats.length > 1 &&
                            idx !== carSeat
                          ) {
                            changeSeat(idx);
                            iframeRef.current.contentWindow.postMessage(
                              JSON.stringify({
                                message:
                                  getCarInfo(carId).seats[idx].interiorValue,
                              }),
                              "*",
                            );
                            // gtmJourneyEventWithCustomFields('select interior color', getCarInfo(carId).brand, inOrEx, { color_interior: ele.name[language] })
                          }
                          gtmJourneyEventWithCustomFields(
                            "select seat",
                            getCarInfo(carId).brand,
                            inOrEx,
                            { interior_feature: ele.name[language] },
                          );
                        }}
                      />
                    </div>
                  );
                })}
              </div>
              {isMobile &&
              seatMenuOpened &&
              getCarInfo(carId).seats.length > 1 ? (
                <ImageComp
                  src="/static/UI/btn_arrow.png"
                  alt="seat-scroll-bottom-button"
                  style={{
                    position: "fixed",
                    width: getButtonIconSize(windowWidth) * 1.1,
                    height: getButtonIconSize(windowWidth) * 1.1,
                    cursor: "pointer",
                    right: 16,
                    bottom: 16,
                    transform: "rotate(-90deg)",
                    opacity: 0.7,
                  }}
                  onClick={() => seatMenuRef.current.scrollBy(0, 1000000)}
                />
              ) : null}
            </FullHeightMenuWrapper>
            <FullHeightMenuWrapper
              width={getResponsiveSize(405, 405)}
              mobileHeight={getResponsiveSize(316, 316)}
              title={localization["notification_txt_4"][language]}
              subTitle={getCarInfo(carId).wheels[carWheel]["name"][language]}
              disclaimer={
                getCarInfo(carId).wheels[carWheel]["disclaimer"]
                  ? getCarInfo(carId).wheels[carWheel]["disclaimer"][language]
                  : null
              }
              opened={wheelMenuOpened}
              closeFunc={() => {
                setButtonsShow(true);
                setOpenWheelMenu(false);
                if (autoPlayOnOff)
                  iframeRef.current.contentWindow.postMessage(
                    JSON.stringify({ message: "cameraRotate", payload: true }),
                  );
                iframeRef.current.contentWindow.postMessage(
                  JSON.stringify({ message: "showAllSpots" }),
                  "*",
                );
              }}
              languageInfo={getLanguageInfo(language)}
            >
              <div
                ref={wheelMenuRef}
                style={{
                  flex: 1,
                  width: "100%",
                  overflowX: "hidden",
                  overflowY: "auto",
                  marginTop: getResponsiveSize(20, 20),
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: isMobile ? "row" : "column",
                    flexWrap: true,
                  }}
                >
                  {getCarInfo(carId).wheels.map((ele, idx) => (
                    <div
                      key={`wheel-${idx}`}
                      style={{
                        cursor: "pointer",
                        width: getWheelSelectorSize(),
                        height: getWheelSelectorSize(),
                        marginTop: !isMobile
                          ? idx === 0
                            ? "36px"
                            : "24px"
                          : 12,
                        background: `url("${createPrefixOfResource()}${ele.image}")`,
                        backgroundSize: `${getWheelSelectorSize()}px ${getWheelSelectorSize()}px`,
                        backgroundPosition: "center center",
                        backgroundRepeat: "no-repeat",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={() => {
                        setCarWheel(idx);
                        iframeRef.current.contentWindow.postMessage(
                          JSON.stringify({ message: "setWheel", payload: idx }),
                          "*",
                        );
                        gtmJourneyEventWithCustomFields(
                          "select wheel",
                          getCarInfo(carId).brand,
                          inOrEx,
                          { wheels: ele.name[language] },
                        );
                      }}
                    >
                      {carWheel === idx ? (
                        <ImageComp
                          alt="wheel-selection"
                          src={"/static/UI/img_wheel_sel@2x.png"}
                          style={{
                            width: getWheelSelectorSize(),
                            height: getWheelSelectorSize(),
                          }}
                        />
                      ) : null}
                    </div>
                  ))}
                </div>
              </div>
              {isMobile &&
              wheelMenuOpened &&
              getCarInfo(carId).wheels.length > 3 ? (
                <ImageComp
                  src="/static/UI/btn_arrow.png"
                  alt="wheel-scroll-bottom-button"
                  style={{
                    position: "fixed",
                    width: getButtonIconSize(windowWidth),
                    height: getButtonIconSize(windowWidth),
                    cursor: "pointer",
                    right: 16,
                    bottom: 16,
                    transform: "rotate(-90deg)",
                    opacity: 0.7,
                  }}
                  onClick={() => wheelMenuRef.current.scrollBy(0, 1000000)}
                />
              ) : null}
            </FullHeightMenuWrapper>
            <FullHeightMenuWrapper
              width={getSpecificationWidth(windowWidth, windowHeight)}
              mobileHeight={windowHeight * 0.5}
              opened={specificationMenuOpened}
              closeFunc={() => {
                setOpenSpecificationMenu(false);
                if (!featuresFrameOpened) {
                  iframeRef.current.contentWindow.postMessage(
                    JSON.stringify({ message: "showUISpots" }),
                  );
                  if (autoPlayOnOff)
                    iframeRef.current.contentWindow.postMessage(
                      JSON.stringify({
                        message: "cameraRotate",
                        payload: true,
                      }),
                    );
                  if (!gyroEnabled) {
                    setButtonsShow(true);
                  }
                }
              }}
              languageInfo={getLanguageInfo(language)}
            >
              <UspIndicatorView
                slides={getCarInfo(carId)[`spots_${inOrEx}`]}
                slideIdx={slideIdx}
                setSlideIdx={(value) => {
                  setSlideIdx(value);
                  iframeRef.current.contentWindow.postMessage(
                    JSON.stringify({
                      message: "cameraRotateToSpot",
                      payload: getCarInfo(carId)[`spots_${inOrEx}`][value].id,
                    }),
                    "*",
                  );
                }}
              />
              <div
                className={getFontClassName("light", language)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: getResponsiveSize(63, 55),
                  paddingBottom: getResponsiveSize(25, 25),
                  width: "90%",
                  fontSize: getResponsiveSize(24, 23),
                  textAlign: "center",
                  overflowY: "visible",
                }}
                dangerouslySetInnerHTML={{
                  __html:
                    getCarInfo(carId)[`spots_${inOrEx}`].length !== 0
                      ? slideIdx < getCarInfo(carId)[`spots_${inOrEx}`].length
                        ? getCarInfo(carId)[`spots_${inOrEx}`][slideIdx].title[
                            language
                          ]
                        : ""
                      : "",
                }}
              ></div>
              {getCarInfo(carId)[`spots_${inOrEx}`].length > 0 ? (
                <UspCarousel
                  carId={carId}
                  inOrEx={inOrEx}
                  language={language}
                  slideIdx={slideIdx}
                  setSlideIdx={setSlideIdx}
                  setUspUrl={setUspUrl}
                  setShowUspModal={setShowUspModal}
                  specificationMenuOpened={specificationMenuOpened}
                  iframeRef={iframeRef}
                />
              ) : null}
            </FullHeightMenuWrapper>
            <FeaturesFrameView
              slides={getCarInfo(carId)[`spots_${inOrEx}`].map((ele) => ({
                title: ele.title[language],
              }))}
              languageInfo={getLanguageInfo(language)}
              slideIdx={slideIdx}
              setSlideIdx={(value) => {
                setSlideIdx(value);
                iframeRef.current.contentWindow.postMessage(
                  JSON.stringify({
                    message: "cameraRotateToSpot",
                    payload: getCarInfo(carId)[`spots_${inOrEx}`][value].id,
                  }),
                  "*",
                );
              }}
              opened={featuresFrameOpened && !specificationMenuOpened}
              closeFunc={() => {
                if (!gyroEnabled) {
                  setButtonsShow(true);
                }
                setOpenFeaturesFrame(false);
                iframeRef.current.contentWindow.postMessage(
                  JSON.stringify({ message: "showUISpots" }),
                );
                if (autoPlayOnOff)
                  iframeRef.current.contentWindow.postMessage(
                    JSON.stringify({
                      message: "cameraRotate",
                      payload: true,
                    }),
                  );
              }}
              carBrand={getCarInfo(carId).brand}
              inOrEx={inOrEx}
              onTitleClick={() => {
                setOpenSpecificationMenu(true);
                // gtmNavigationInteraction('sticky menu', `${inOrEx} features`, getCarInfo(carId).brand)
              }}
            />
            <NotificationModal
              opened={
                notificationShow[`car_${inOrEx}`] && notificationModalShow
              }
              closeFunc={() => {
                setShowNotificationModal(false);
                dispatch({
                  type: "CHANGE_CAR_NOTIFICATION",
                  inOrEx: `car_${inOrEx}`,
                  value: false,
                });
              }}
              windowWidth={windowWidth}
              windowHeight={windowHeight}
              language={language}
              inOrEx={inOrEx}
              getNotificationModalWidth={getNotificationModalWidth}
              getNotificationIconWidth={getNotificationIconWidth}
              getNotificationModalPartStyle1={getNotificationModalPartStyle1}
              getNotificationModalPartStyle2={getNotificationModalPartStyle2}
            />
          </div>
          {!loadingRequired && loadingEnded && showButtons ? (
            <InfoTextDiv onModel={windowHeight > windowWidth} />
          ) : featuresFrameOpened ? (
            <InfoTextDiv onModel={windowHeight > windowWidth} />
          ) : null}
          {showGallery ? (
            <FullScreenImageCarousel
              carId={carId}
              closeFunc={() => setShowGallery(false)}
            />
          ) : null}
          <MultimediaGallery
            opened={showMultimediaGallery}
            title={localization["car_menu_txt_6"][language]}
            carCode={getCarInfo(carId).carCode}
            medias={getCarInfo(carId).multimedias}
            languageInfo={getLanguageInfo(language)}
            closeFunc={() => setShowMultimediaGallery(false)}
          />
          <UspModal
            opened={showUspModal}
            uspUrl={uspUrl}
            languageInfo={getLanguageInfo(language)}
            closeFunc={() => {
              setShowUspModal(false);
              setUspUrl(null);
            }}
          />
          <ScreenCaptureView
            opened={showScreenCapture}
            languageInfo={getLanguageInfo(language)}
            carId={carId}
            iframeRef={iframeRef}
            exOrInterior={inOrEx}
            capturedScreen={capturedScreen}
            setCapturedScreen={setCapturedScreen}
            closeFunc={() => {
              setShowScreenCapture(false);
              setButtonsShow(true);
              iframeRef.current.contentWindow.postMessage(
                JSON.stringify({ message: "showAllSpots" }),
              );
              if (autoPlayOnOff) {
                iframeRef.current.contentWindow.postMessage(
                  JSON.stringify({ message: "cameraRotate", payload: true }),
                );
              }
            }}
          />
        </PageWrapper>
      ) : null}
    </>
  );
};

export default CarSimulatePage;
